import { Component, OnInit } from "@angular/core";
import { Router, ActivatedRoute, Params } from "@angular/router";
import { FormBuilder, Validators, FormGroup } from "@angular/forms";
import { Unidade } from "./../../../models/unidade";
import { InscricaoService } from "./../../../services/inscricao.service";
import { CustomValidator } from "../../shared/validators/custom.validator";

import { Util } from "../../shared/util";
import { MessageService } from "primeng/components/common/messageservice";
import { WebPage } from "../../shared/web-page";
import { UnidadeService } from "../../shared/services/unidade.service";

@Component({
  templateUrl: "./valida-dados.component.html",
})
export class ValidaDadosComponent extends WebPage implements OnInit {
  errorMessage: string;

  idFase;
  unidades;

  isCpfValido: boolean;
  empresaNaoCadastrada = false;
  rendaInvalida = false;
  isPossuiCadUnico: any;

  get unidade() {
    return this.form.get("unidade");
  }
  get idUnidade() {
    return this.form.get("idUnidade");
  }
  get cpf() {
    return this.form.get("cpf");
  }
  get cnpj() {
    return this.form.get("cnpj");
  }
  get rendaIndividual() {
    return this.form.get("rendaIndividual");
  }
  get dataNascimento() {
    return this.form.get("dataNascimento");
  }

  public form: FormGroup;
  constructor(
    private fb: FormBuilder,
    messageService: MessageService,
    private inscricaoService: InscricaoService,
    private unidadeService: UnidadeService,
    private router: Router,
    private route: ActivatedRoute
  ) {
    super(messageService);

    this.form = this.fb.group({
      idUnidade: ["", Validators.required],
      cpf: ["", [Validators.maxLength(14), Validators.required]],
      rendaIndividual: [""],
      dataNascimento: ["", Validators.required],
      habilitacao: ["", Validators.required],
      isPossuiCadUnico: ["",Validators.required],
      isPossuiVinculoProfissional: [""],
      isResidente: [""],
      isConcordo: [""],
    });

    this.form.controls['isPossuiVinculoProfissional'].setValue(false);
    this.form.controls['isResidente'].setValue(false);
    this.form.controls['isConcordo'].setValue(false);

    this.route.paramMap.subscribe(
      (params) => (this.idFase = params.get("idFase"))
    );
  }

  ngOnInit() {
    this.isLoading = true;
    this.unidadeService
      .getUnidadesParticipantesInscricoesAbertasByFase(this.idFase)
      .finally(() => (this.isLoading = false))
      .subscribe(
        (unidades) => {
          this.unidades = unidades;
        },

        (error) => this.gerenciaErro(error)
      );
  }

  validaCpf() {
    if (!Util.isCpf(Util.limpaCpf(this.cpf.value))) {
      this.messageService.add({
        severity: "error",
        summary: "Atenção",
        detail: "CPF inválido.",
      });
      this.cpf.setValue("");
    }
  }

  validaCnpjDeTransporte() {
    if (this.cnpj.value === "") {
      return;
    }

    this.isLoading = true;
    this.inscricaoService
      .validaCnpjDeTransporte(Util.limpaCnpj(this.cnpj.value))
      .finally(() => (this.isLoading = false))
      .subscribe(
        (resultado) => {
          this.empresaNaoCadastrada = false;

          if (resultado.toString() === "invalido") {
            this.messageService.add({
              severity: "error",
              summary: "Atenção",
              detail: "CNPJ inválido.",
            });
            this.cnpj.setValue("");
            this.empresaNaoCadastrada = true;
          }
        },
        (error) => this.gerenciaErro(error)
      );
  }

  validaSalario() {
    const value = this.rendaIndividual.value.toString();
    // this.rendaInvalida = value === "0,00" || value === "";
  }

  submit() {
    console.log(JSON.stringify(this.form.value));
    this.validarResidencia();
    this.validarCienciaPenal();
    let isPermitirCadstro = false;
    //RN1
    switch(this.form.controls['habilitacao'].value){
      case '1':
        if (this.validadata(18)){
          const rendaFamiliar = Number(this.form.controls['rendaIndividual'].value);
          if(this.validarCadUnico(rendaFamiliar,1)){
            if(this.validarHabilitacao(1)){
              this.messageService.add({
                severity: "info",
                summary: "Informe",
                detail: "Selecionado Primeira Habilitação Categoria A.",
              });
              isPermitirCadstro = true;
            }else{isPermitirCadstro = false;}
          }
        }else{
          isPermitirCadstro = false;
        }
        break;
      case '2':
        if (this.validadata(18)){
          const rendaFamiliar = Number(this.form.controls['rendaIndividual'].value);
          if(this.validarCadUnico(rendaFamiliar,1)){
            if(this.validarHabilitacao(1)){
              this.messageService.add({
                severity: "info",
                summary: "Informe",
                detail: "Selecionado Primeira Habilitação Categoria B.",
              });
              isPermitirCadstro = true;
            }else{isPermitirCadstro = false;}
          }
        }else{
          isPermitirCadstro = false;
        }
        break;
      case '3':
        if (this.validadata(18)){
          const rendaFamiliar = Number(this.form.controls['rendaIndividual'].value);
          if(this.validarCadUnico(rendaFamiliar,2)){
            if(this.validarHabilitacao(2)){
              this.messageService.add({
                severity: "info",
                summary: "Informe",
                detail: "Selecionado Adição Categoria A.",
              });
              isPermitirCadstro = true;
            }
          }
        }else{
          isPermitirCadstro = false;
        }
        break;
      case '4':
        if (this.validadata(18)){
          const rendaFamiliar = Number(this.form.controls['rendaIndividual'].value);
          if(this.validarCadUnico(rendaFamiliar,2)){
            if(this.validarHabilitacao(2)){
              this.messageService.add({
                severity: "info",
                summary: "Informe",
                detail: "Selecionado Adição Categoria B.",
              });
              isPermitirCadstro = true;
            }
          }
        }else{
          isPermitirCadstro = false;
        }
        break;
      case '6':
        if (this.validadata(21)){
          this.messageService.add({
            severity: "info",
            summary: "Informe",
            detail: "Selecionado Mudança de Categoria para Categoria D.",
          });
          isPermitirCadstro = true;
        }else{
          isPermitirCadstro = false;
        }
        break;
      case '7':
        if (this.validadata(21)){
          this.messageService.add({
            severity: "info",
            summary: "Informe",
            detail: "Selecionado Mudança de Categoria para Categoria E.",
          });
          isPermitirCadstro = true;
        }else{
          isPermitirCadstro = false;
        }
        break;
      case '8':
        if (this.validadata(21)){
          this.messageService.add({
            severity: "info",
            summary: "Informe",
            detail: "Selecionado Curso de Capacitação de Motofretista.",
          });
          isPermitirCadstro = true;
        }else{
          isPermitirCadstro = false;
        }
        break;
      default:
        this.messageService.add({
          severity: "error",
          summary: "Atenção",
          detail: "Nenhuma opção foi selecionada.",
        });
        isPermitirCadstro = false;
        ;
    }
    if(isPermitirCadstro == false) return;

    const cpfLimpo = Util.limpaCpf(this.cpf.value);
    //const cnpjLimpo = Util.limpaCnpj(this.cnpj.value);
    const dataNascimento = this.dataNascimento.value;
    const idOfertaPretendida = this.form.controls['habilitacao'].value;
    this.isLoading = true;
    // this.inscricaoService.validaDados(cnpjLimpo, dataNascimento, cpfLimpo, this.idFase)
    this.inscricaoService
      .validaDadosNova('', dataNascimento, cpfLimpo, this.idFase,idOfertaPretendida)
      .finally(() => (this.isLoading = false))
      .subscribe(
        (resultado) => {
          if (resultado === "validamaior") {
            this.messageService.add({
              severity: "error",
              summary: "Atenção",
              detail: "A idade mínima de participação é de 21 anos!",
            });
            return;
          }
          if (resultado === "validacandidato") {
            this.messageService.add({
              severity: "error",
              summary: "Atenção",
              detail: "Candidato já inscrito!",
            });
            return;
          }

          const data: string = this.dataNascimento.value;
          localStorage.setItem(
            "dadosPrincipais",
            JSON.stringify({
              idFase: this.idFase,
              idUnidade: this.idUnidade.value,
              cpf: this.cpf.value,
              cnpj: '',
              salario: this.rendaIndividual.value,
              dataNascimento: data.substr(6, 4) + "-" + data.substr(3, 2) + "-" + data.substr(0, 2),
              razaoSocial: resultado,
              habilitacao: this.form.controls['habilitacao'].value,
              isPossuiCadUnico: this.form.controls['isPossuiCadUnico'].value,
              isPossuiVinculoProfissional: this.form.controls['isPossuiVinculoProfissional'].value,
              isPossuiCienciaPenal: this.form.controls['isConcordo'].value,
            })
          );
          this.router.navigate(["/inscricao-form/" + this.idFase]);
        },
        (error) => this.gerenciaErro(error)
      );
  }

  buscarEmpresaParticipanteUnidade(evento: any) {
    if (!evento.target.value) {
      return;
    }

    const cnpj = evento.target.value.replace(/\D/g, "");

    this.inscricaoService.getEmpresaParticipanteUnidade(cnpj).subscribe((x) => {
      if (x) {
        // this.unidade.setValue(`${x.nomeUnidade}/${x.siglaUf} ${x.tipologia}`);
        this.idUnidade.setValue(x.idUnidade);
      } else {
        // this.unidade.setValue("");
        this.idUnidade.setValue("");
      }
    });
  }
  //RN01
  validadata(idadeHabil:number){
   console.log(idadeHabil);
    var data = this.form.controls['dataNascimento'].value; // pega o valor do input
    data = data.replace(/\//g, "-"); // substitui eventuais barras (ex. IE) "/" por hífen "-"
    var data_array = data.split("-"); // quebra a data em array

    // para o IE onde será inserido no formato dd/MM/yyyy
    if(data_array[0].length != 4){
       data = data_array[2]+"-"+data_array[1]+"-"+data_array[0]; // remonto a data no formato yyyy/MM/dd
    }

    // comparo as datas e calculo a idade
    var hoje = new Date();
    var nasc  = new Date(data);
    var idade = hoje.getFullYear() - nasc.getFullYear();
    console.log(idade);
    var m = hoje.getMonth() - nasc.getMonth();
    if (m < 0 || (m === 0 && hoje.getDate() < nasc.getDate())) idade--;

    if(idade < 18){
       alert("Não é permitido a inscrição de menores de 18 anos.");
       return false;
    }
    if(idade < idadeHabil){
      alert(`Não é permitido a inscrição de menores de ${idadeHabil} anos.`);
      return false;
    }
    if(idade >= idadeHabil && idade <= 60){
       return true;
    }
    // se for maior que 60 não vai acontecer nada!
    return false;
  }
  //RN02
  validarCadUnico(rendaFamiliar:number,habilitacao:number){
    switch(habilitacao){
      case 1:
        return this.validarRendaCadUnico(rendaFamiliar);
      case 2:
        return this.validarRendaCadUnico(rendaFamiliar);
      default:
        return true;
    }
  }
  validarRendaCadUnico(renda:number){
    //Não permitir inscrição para renda familiar maior que R$ 3960,00.
    if(renda > 3960){
      alert("Sua renda familiar esta acima dos critérios definidos pelo CadÚnico.");
      return false;
    }
    return true;
  }
  //RN03
  validarHabilitacao(habilitacao:number){
    console.log('Inscrito' + this.form.controls['isPossuiCadUnico'].value);
    const isIncritoCadUnico = this.form.controls['isPossuiCadUnico'].value;
    switch(habilitacao){
      case 1:
        if(isIncritoCadUnico == 1) return true;
        this.exibirObrigacaoCadUnico();
        return false;
      case 2:
        if(isIncritoCadUnico == 1) return true;
        this.exibirObrigacaoCadUnico();
        return false;
      default:
        return true;
    }
  }
  exibirObrigacaoCadUnico(){
    alert('É obrigatório estar inscrito no CadUnico para concorrer ao programa. O comprovante de inscrição precisa estar em mãos até o dia de assinar o termo na unidade.');
  }
  //RN04
  validarResidencia(){
    if(this.form.controls['isResidente'].value == true) return true;
    alert('É obrigatório residir em Santa Catarina há mais de 2 anos para participar do programa Emprego na Pista.');
    return false;
  }
  validarCienciaPenal(){
    if(this.form.controls['isConcordo'].value == true) return true;
    alert('É obrigatório ter ciência sobre as penalidades previstas em caso de falsidade nas informações.');
    return false;
  }
}



// WEBPACK FOOTER //
// ./src/app/components/candidato/valida-dados/valida-dados.component.ts